import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import * as R from 'ramda';

export const SkipRegister = () => {
	const hideModal = () => {
		$('.modal').modal("hide");
	}
	const user = useSelector(state => state.user);

	return (
		<div className="modal fade px-0" id="skipRegister" aria-labelledby="skipRegisterLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<div className="modal-header">
						<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h5 className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="skipRegisterLabel">Enregistrer et continuer plus tard</h5>
						</div>
					</div>
					<div className="modal-body py-0">
						<p>Vous pouvez remplir votre dossier en plusieurs fois. <br />Afin de conserver les données déjà renseignées, merci de saisir votre e-mail ou numéro de téléphone mobile :</p>
						<form className="grid grid-lg-3 align-items-center">
							<div className="form-group">
								<label className="h6 font-weight-bolder" htmlFor="processus">Numéro de processus</label>
								<p className="h5 my-auto form-control border-0 px-0" id="processus">{!R.isNil(user.user) && !R.isNil(user.user.processNumber) && user.user.processNumber ? user.user.processNumber :'N/D'}</p>
							</div>
							<div className="form-group">
								<label className="h6 font-weight-bolder" htmlFor="emailSkip">Votre e-mail</label>
								<input type="email" className="form-control" id="emailSkip" placeholder="votreemail@mail.fr"  defaultValue={!R.isNil(user.user) ? user.user.email: ''}/>
							</div>
							<div className="form-group">
								<label className="h6 font-weight-bolder" htmlFor="mobileSkip">Téléphone mobile</label>
								<input type="text" className="form-control" id="mobileSkip" placeholder="00 00 00 00 00" defaultValue={!R.isNil(user.user) ? user.user.phoneNumber: ''}/>
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light mr-2" data-dismiss="modal">Retour</button>
						<Link to="/index" className="btn btn-info" onClick={hideModal}>Oui</Link>
					</div>
				</div>
			</div>
		</div>
	)
}